  class NerveGraphicPreviews extends HTMLElement {
    #request = 0;
    connectedCallback() { this.addEventListener('click', this.#select); }
    disconnectedCallback() { this.#request++; this.removeEventListener('click', this.#select); }
    #select = async (event) => {
      const button = event.target.closest('button[data-media-id]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled || !button.dataset.imageUrl) return;
      const card = this.closest('.resource-card');
      const currentImage = card?.querySelector('.resource-card__media img:not(.resource-card__image--secondary)');
      if (!currentImage) return;
      const request = ++this.#request;
      const image = new Image();
      const responsiveSrcset = button.dataset.imageSrcset;
      if (responsiveSrcset) {
        image.sizes = button.dataset.imageSizes || currentImage.sizes;
        image.srcset = responsiveSrcset;
      }
      image.src = button.dataset.imageUrl;
      try { await image.decode(); } catch { return; }
      if (request !== this.#request || !this.isConnected) return;
      if (button.dataset.variantId) {
        const productUrl = new URL(this.dataset.productUrl, window.location.origin);
        for (const link of card.querySelectorAll('a[href]')) {
          const url = new URL(link.href, window.location.origin);
          if (url.origin !== productUrl.origin || url.pathname !== productUrl.pathname) continue;
          url.searchParams.set('variant', button.dataset.variantId);
          link.href = url.toString();
        }
      }
      if (responsiveSrcset) {
        currentImage.sizes = image.sizes;
        currentImage.srcset = image.srcset;
      } else {
        currentImage.removeAttribute('srcset');
      }
      currentImage.src = image.src;
      currentImage.alt = `${this.dataset.productTitle} — ${button.getAttribute('aria-label')}`;
      currentImage.dataset.mediaId = button.dataset.mediaId;
      card.dataset.graphicColorSelected = button.dataset.mediaId;
      const wrapper = card.closest('.resource-card__wrapper');
      if (wrapper?.hasAttribute('data-featured-media-url')) wrapper.dataset.featuredMediaUrl = responsiveSrcset ? (image.currentSrc || image.src) : image.src;
      for (const candidate of this.querySelectorAll('button')) candidate.setAttribute('aria-pressed', String(candidate === button));
    };
  }
  if (!customElements.get('nerve-graphic-previews')) customElements.define('nerve-graphic-previews', NerveGraphicPreviews);